<template>
  <div class="row q-col-gutter-sm">
    <div class="col-6">
      <div class="text-h5">My Monthly Totals</div>
      <div class="row q-gutter-sm" v-if="!loadingMonthlyTotals">
        <app-aggregation-card
          icon="layers"
          color="brand1"
          label="New Quotes"
          :value="userQuotesCount('newQuoteCount')"
        />
        <app-aggregation-card
          icon="message"
          color="brand2"
          label="New Followups"
          :value="0"
        />
        <app-aggregation-card
          icon="shopping_cart"
          color="brand3"
          label="New Orders"
          :value="userQuotesCount('newOrderCount')"
        />
        <app-aggregation-card
          icon="local_offer"
          color="brand4"
          label="Dispatches"
          :value="userQuotesCount('dispatchCount')"
        />
      </div>
      <div class="q-mt-sm" v-if="!loadingMonthlyTotals">
        <span class="text-caption">Closing Rate</span>
        <q-linear-progress
          :value="
            userQuotesCount('dispatchCount') /
            userQuotesCount('newQuoteCount')
          "
        />
      </div>
      <div class="text-h5 q-mt-lg">Company Monthly Totals</div>
      <div class="row q-gutter-sm" v-if="!loadingMonthlyTotals">
        <app-aggregation-card
          icon="layers"
          color="brand1"
          label="New Quotes"
          :value="companyQuotesCount('newQuoteCount')"
        />
        <app-aggregation-card
          icon="message"
          color="brand2"
          label="New Followups"
          :value="0"
        />
        <app-aggregation-card
          icon="shopping_cart"
          color="brand3"
          label="New Orders"
          :value="companyQuotesCount('newOrderCount')"
        />
        <app-aggregation-card
          icon="local_offer"
          color="brand4"
          label="Dispatches"
          :value="companyQuotesCount('dispatchCount')"
        />
      </div>
      <div class="q-mt-sm" v-if="!loadingMonthlyTotals">
        <span class="text-caption">Closing Rate</span>
        <q-linear-progress
          :value="
           companyQuotesCount('dispatchCount') /
            companyQuotesCount('newQuoteCount')
          "
        />
      </div>
      <app-dashboard-calendar-card class="q-mt-lg" />
    </div>
    <div class="col-6 q-gutter-y-sm">
      <div class="row q-gutter-sm">
        <app-sales-tracker-card
          class="col"
          v-if="!loadingMonthlyTotals"
          :data="quotesMonthlyTotals"
        />
        <app-team-members-contact-card class="col" />
      </div>
      <div class="row">
        <app-today-charges-card class="col" />
        <app-estimated-transport-times-card class="col" />
      </div>
      <div class="row q-gutter-x-sm">
        <app-state-abbrs-card />
        <app-timezone-map-card />
      </div>
    </div>
  </div>
</template>

<script>
import AppAggregationCard from '@client/components/cards/aggregation-card';
import AppDashboardCalendarCard from '@client/components/cards/dashboard-calendar-card';
import AppSalesTrackerCard from '@client/components/cards/sales-tracker-card';
import AppEstimatedTransportTimesCard from '@client/components/cards/estimated-transport-times-card';
import AppTeamMembersContactCard from '@client/components/cards/team-members-contact-card';
import AppStateAbbrsCard from '@client/components/cards/state-abbrs-card';
import AppTodayChargesCard from '@client/components/cards/today-charges-card';
import AppTimezoneMapCard from '@client/components/cards/timezone-map-card';
import graphql from '@client/graphql';

export default {
  metaInfo: {
    title: 'AutoBook Pro - Dashboard'
  },
  components: {
    AppAggregationCard,
    AppDashboardCalendarCard,
    AppSalesTrackerCard,
    AppEstimatedTransportTimesCard,
    AppTeamMembersContactCard,
    AppStateAbbrsCard,
    AppTodayChargesCard,
    AppTimezoneMapCard
  },
  apollo: {
    quotesMonthlyTotals: {
      query: graphql.queries.getQuotesMonthlyTotals,
      watchLoading(isLoading) {
        this.loadingMonthlyTotals = isLoading;
      }
    },
    currentUser: {
      query: graphql.queries.currentUser
    }
  },

  methods: {
    userQuotesCount(key) {
      return this.quotesMonthlyTotals.find((qmt) => qmt.userId === this.currentUser.id)?.[key];
    },
    companyQuotesCount(key) {
      return this.quotesMonthlyTotals.reduce((acc, obj) => acc + obj[key], 0);
    }
  },
  data() {
    return {
      loadingMonthlyTotals: false
    };
  }
};
</script>
<style lang="style"></style>
